import * as S from './styles'
import theme from 'src/styles/theme'

import useMediaQuery from '@mui/material/useMediaQuery'

interface IButtonContainerProps {
  children?: any
  justifyContent?: string
  marginOff?: boolean
}

const ButtonContainer = (props: IButtonContainerProps) => {
  const matches: boolean = useMediaQuery(`(min-width: ${theme.screen.medium})`)

  return (
    <S.Wrapper
      justifyContent={props.justifyContent}
      matches={matches}
      marginOff={props.marginOff}
    >
      {props.children}
    </S.Wrapper>
  )
}

export { ButtonContainer }
export type { IButtonContainerProps }
